import { useContext } from "react";
import { PreferredLanguageContext } from "./PreferredLanguageProvider";

export const usePreferredLanguage = () => {
  const language = useContext(PreferredLanguageContext);
  if (language == null) {
    throw new Error(
      "usePreferredLanguage is used outside of PreferredLanguageProvider"
    );
  }

  return language;
};
